import { AxiosError } from 'axios'

export const handleAxiosError = (error: unknown): string => {
  if (error instanceof AxiosError) {
    if (error.response) {
      return `Server error: ${error.response.status} - ${error.response.data?.message || 'Unknown error'}`
    }
    if (error.request) {
      return 'Network error: No response received'
    }
    return `Request error: ${error.message}`
  }
  return 'An unexpected error occurred'
}

export const isAxiosError = (error: unknown): error is AxiosError => {
  return error instanceof AxiosError
}
